type State = {
	idVeiculoTipo: number;
	idVeiculoMarca: number;
	descricao: string;
	codigoModeloFipe: string;
};

type Action =
	| { type: 'SET_VALUE'; field: string; payload: string }
	| { type: 'SET_SELECT_OPTION'; field: string; value: string | number };

export const newModelFormInitialState: State = {
	idVeiculoTipo: 0,
	idVeiculoMarca: 0,
	descricao: '',
	codigoModeloFipe: '',
};

export const newModelFormReducer = (state: State, action: Action) => {
	switch (action.type) {
		case 'SET_VALUE':
			return {
				...state,
				[action.field]: action.payload,
			};
		case 'SET_SELECT_OPTION':
			return {
				...state,
				[action.field]: action.value,
			};
		default:
			return state;
	}
};
